import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { InstrumentType } from '@zero/shared/util-models';
import { Filter, Trade } from '@zero/statistics/domain';

@Directive()
export class TradeTickerBase {
  @Input() public trades: Trade[];
  @Input() public loading: boolean;
  @Input() public filter: Filter;
  @Input() public instrumentTypeOnly: InstrumentType;

  @Output() public filterChange = new EventEmitter<Filter>();

  public readonly InstrumentType = InstrumentType;
  public readonly filters: Filter[] = Object.values(InstrumentType).filter((type) => this.isUntradableType(type));

  private isUntradableType(type: InstrumentType): boolean {
    return type !== InstrumentType.Index && type !== InstrumentType.Currency && type !== InstrumentType.Commodity;
  }
}
